export default {
  failed_to_open: 'Das Onboarding für dieses Restaurant konnte nicht geöffnet werden. Bitte versuche es erneut.',
};
